import React, { useEffect, useRef } from "react";
import './LandingPage1.css';






export default function LandingPage() {
  const sliderRef = useRef(null);

useEffect(() => {
  const slider = sliderRef.current;
  let start = null;

  const speed = 0.01; // מהירות

  const animate = (timestamp) => {
    if (!start) start = timestamp;
    const elapsed = timestamp - start;

    if (slider) {
      const move = elapsed * speed;
      slider.style.transform = `translateX(-${move}px)`;

      // איפוס ללופ
      if (move >= slider.scrollWidth / 2) {
        start = timestamp;
      }
    }

    requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
}, []);

  return (
<div className="min-h-screen bg-white text-gray-800 font-sans" dir="rtl">
          {/* Hero Section */}
<div className="page">
<section className="hero">
  <h1>איטום באמצעות סנפלינג</h1>
  <p>
אחת מהדרכים לביצוע עבודות איטום בקירות חיצוניים, היא באמצעות סנפלינג.
בשביל לבצע איטום באמצעות סנפלינג, על הפועל להיות מיומן ומקצועי.
על הפועל לגלות מקצועיות רבה במלאכת האיטום, וגם במלאכת הסנפלינג.
ולכן, אנו דואגים להכשיר ולבטח את העובדים שלנו לשם כך ולהעסיק עובדים מקצועיים ובעלי ניסיון מעשי בתחום הסנפלינג  ובעלי ידע ומיומנות במלאכת האיטום.   </p>
</section>

<section className="content">
  <h2>חומרי האיטום המומלצים ביותר כדי לתקן גג שאינו אטום מספיק:
   </h2>

  <ul>
    <li>זפת חם</li>
    <li>יריעות ביטומניות</li>
    <li>חומרי איטום פולימריים</li>
    <li>יריעות PVC</li>
    <li>   חומרי איטום במרקם משחתי</li>
  </ul>

  <p className="highlight">
         תיקון הגג נועד כדי לשפר את איכות החיים של הדיירים, יש לבצע אותה באופן היעיל והמקצועי ביותר
  </p>
</section>
</div>

      {/* Clients Slider */}
      <section className="bg-white py-12 overflow-hidden">
<h2 className="text-center text-2xl font-semibold mb-10 text-black">
 <span className="highlight">בין לקוחותינו :</span>
</h2>
<br/><br/>

<div className="slider-wrapper">
  <div className="slider-track">
    {[...Array(6)].map((_, i) => (
      <div key={i} className="slide">
        <img src={`/logos/${i + 1}.jpeg`} />
      </div>
    ))}

    
  </div>
</div>
      </section>
    </div>
  );
}
